/**
 * Composant pour afficher l'écran de blocage
 * @returns 
 */
import { AlertTriangle, RefreshCw, LogOut } from "lucide-react";
import { resetConfiguration } from "@/services/config.services";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/timeclock/Logo";

export const BlockedScreen = () => {
  
  const handleReconfigure = () => {
    resetConfiguration();
    window.location.href = "/";
  };

  return (
    <div className="min-h-dvh bg-gray-50 flex flex-col overflow-hidden">
      {/* Header - Même style que TimeClock */}
      <header className="flex items-center justify-between px-4 py-2.5 border-b border-gray-200 bg-white">
        <div className="flex items-center gap-2">
          {/* Espace vide pour équilibrer le header */}
        </div>

        <Logo />

        <div className="flex items-center gap-2">
          <Button
            onClick={handleReconfigure}
            variant="outline"
            size="sm"
            className="flex items-center gap-2 bg-white hover:bg-gray-50 border-gray-300 text-gray-700 shadow-sm"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Reconfigurer</span>
          </Button>
        </div>
      </header>

      {/* Main Content - Style cohérent avec TimeClock */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 pb-12">
        {/* Icône d'alerte */}
        <div className="flex justify-center mb-8">
          <div className="w-32 h-32 bg-red-500 rounded-full flex items-center justify-center shadow-lg">
            <AlertTriangle className="h-16 w-16 text-white stroke-[3]" />
          </div>
        </div>

        {/* Titre */}
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
          Tablette bloquée
        </h1>

        {/* Message principal */}
        <p className="text-xl md:text-2xl text-gray-700 mb-4 text-center max-w-2xl">
          Cette tablette a été désactivée depuis le backoffice.
        </p>

        {/* Message secondaire */}
        <p className="text-lg text-gray-600 mb-12 text-center max-w-xl">
          Veuillez contacter l'administrateur pour plus d'informations.
        </p>

        {/* Boutons d'action */}
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md">
          <Button
            onClick={() => window.location.reload()}
            className="flex-1 h-16 text-lg font-semibold bg-primary hover:bg-primary/90 text-white shadow-lg flex items-center justify-center gap-2"
          >
            <RefreshCw className="h-5 w-5" />
            Réessayer
          </Button>

          <Button
            onClick={handleReconfigure}
            variant="outline"
            className="flex-1 h-16 text-lg font-semibold bg-white hover:bg-gray-50 border-gray-300 text-gray-700 shadow-sm flex items-center justify-center gap-2"
          >
            <LogOut className="h-5 w-5" />
            Reconfigurer
          </Button>
        </div>
      </main>
    </div>
  );
};
